
import ReactDOM from 'react-dom/client'; // Ensure you are using the correct import for React 18
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
